<template>
  <Navbar regloginpass logourl="/rental" />

  <section id="resetPasswordComplete">
    <div class="container pt-5" data-aos="fade-up">
      <div class="section-caption">
        <h2 class="mt-2">Reset hasła</h2>
      </div>
      <div class="tile">
        <div class="section-content">
          <div class="container-fluid">
            <div class="row d-flex justify-content-center mt-3">
              <div class="col-12">
                <Alert
                  alert-type="alert-success"
                  alert-text="Reset hasła zakończony powodzeniem.
              Na podany wcześniej adres email została wysłana wiadomość z loginem i tymczasowym hasłem do zalogowania na konto.
              Sprawdź folder SPAM na swojej poczcie, jeśli nie możesz odnaleźć wiadomości z danymi do logowania."
                  class="alert"
                />
                <div class="text-center">
                  <button class="btn-standard" @click="onMainPageButtonClick">
                    Strona główna
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- Stopka -->
  <Footer />
</template>

<script>
import { scrollToTop } from "@/utils/helpers";
import Alert from "@/components/Alert.vue";
import Footer from "@/components/Footer.vue";
import Navbar from "@/components/Navbar.vue";
export default {
  name: "RegistrationCompleteView",
  components: { Navbar, Footer, Alert },

  mounted() {
    scrollToTop();
  },

  methods: {
    onMainPageButtonClick() {
      this.$router.push(this.routePath.Login);
    },
  },
};
</script>

<style scoped></style>
